
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules/privacy-policy",
      function () {
        return require("private-next-pages/rules/privacy-policy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules/privacy-policy"])
      });
    }
  